import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener, Input } from '@angular/core';
import { ProfileMembershipInformationMin } from '../../shared/profile-membership-informaiton-min.model';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../../shared/widgets/value-accessors/object-value-accessor';
import { BenefitService } from '../../../benefits/shared/benefit.service';
import { MemberSourceService } from 'src/app/member/shared/member-source.service';
import { SelectItem } from 'primeng/api';
import { PagedSearch } from 'src/app/shared';

@Component({
  selector: 'wl-profile-edit-membership',
  templateUrl: 'profile-edit-membership.component.html',
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditMembershipComponent),
    CreateObjectValueValidationProvider(ProfileEditMembershipComponent),
    BenefitService,
  ],
    standalone: false
})
export class ProfileEditMembershipComponent extends ObjectValueAccessor<ProfileMembershipInformationMin> {
  @Input() isModal = false;
  public membershipLevels: any[];
  public memberSourceItems: SelectItem[] = [];

  public constructor(private _membershipLevelService: BenefitService, private _memberSourceService: MemberSourceService) {
    super(new ProfileMembershipInformationMin(), false);
    this.membershipLevels = [];
  }

  ngOnInit() {
    this._membershipLevelService.getMembershipLevels().then((data) => {
      this.membershipLevels = data.Result;
    });

    this._memberSourceService.getPaged({ PageSize: 0 } as PagedSearch).then((sources) => {
      this.memberSourceItems = sources.Result.map<SelectItem>((source) => {
        return { label: source.MemberSource, value: source.MemberSource };
      });
    });
  }

  ngOnDestroy() {}
}
